// Avoid `console` errors in browsers that lack a console.
(function() {
  var method;
  var noop = function () {};
  var methods = [
    'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
    'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
    'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
  ];
  var length = methods.length;
  var console = (window.console = window.console || {});

  while (length--) {
    method = methods[length];

    // Only stub undefined methods.
    if (!console[method]) {
        console[method] = noop;
    }
  }
}());

// Namespace
var cv = new Mn.Application();
cv.mixins = {};
cv.utils = {};

// Global error handler
$(document).ajaxError( function(e, xhr, options){
  console.log(e);
  console.log(xhr.status);

  if(xhr.status == 401){
    window.location = '/logout';
  }
});

// Set Moment Locale
moment.locale('en');

// Event aggregator
var vent = _.extend({}, Backbone.Events);